import { useState, useEffect, useCallback, useMemo, useRef } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { Calendar } from "@/components/ui/calendar";
import {
  LayoutDashboard,
  Scissors,
  Image,
  Star,
  CalendarDays,
  MessageSquare,
  LogOut,
  Plus,
  Trash2,
  Pencil,
  X,
  Save,
  Upload,
  Loader2,
  Bell,
  CheckCircle,
  Sparkles,
  Megaphone,
  ExternalLink,
  Copy,
  Eye,
  EyeOff,
  Send,
  Phone,
  Users,
  Mail,
  CalendarPlus,
  AlertTriangle,
  RotateCcw,
} from "lucide-react";
import { API, SITE_URL, authHeaders, resolveUrl, ImageUploadField } from "./shared";

const MessagesTab = () => {
  const [messages, setMessages] = useState([]);

  const fetchMessages = useCallback(async () => {
    try {
      const res = await axios.get(`${API}/contact-messages`, authHeaders());
      setMessages(res.data);
    } catch (err) {
      // error handled silently
    }
  }, []);

  useEffect(() => { fetchMessages(); }, [fetchMessages]);

  return (
    <div data-testid="admin-messages-tab">
      <h2 className="font-serif text-2xl text-brand-text mb-6">Messages</h2>
      {messages.length === 0 ? (
        <p className="font-sans text-sm text-brand-text-muted">No messages yet.</p>
      ) : (
        <div className="space-y-3">
          {messages.map((msg) => (
            <div key={msg.id} className="p-4 border border-brand-border bg-brand-surface" data-testid={`admin-message-${msg.id}`}>
              <div className="flex items-center justify-between mb-2">
                <p className="font-sans text-sm font-medium text-brand-text">{msg.name}</p>
                <p className="font-sans text-xs text-brand-text-muted">{new Date(msg.created_at).toLocaleDateString()}</p>
              </div>
              <p className="font-sans text-xs text-brand-gold mb-1">{msg.email}{msg.phone ? ` | ${msg.phone}` : ""}</p>
              <p className="font-sans text-sm text-brand-text-muted">{msg.message}</p>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default MessagesTab;
